import { PaginationRequest, PaginationResponse } from '@repo/ui/data-table'

import {
  StaffApplicationFilters,
  StaffApplicationLight
} from '../../lib/types/models/staff-application/staff-application'
import { encodeNestedObject } from '../../lib/utils/functions/misc.functions'
import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export function getStaffApplications(input: PaginationRequest<StaffApplicationFilters>) {
  return restApiClient
    .url(encodeNestedObject(constructApiUrl(API.candidate.getAll.url, null), input))
    .get<PaginationResponse<StaffApplicationLight>>()
}
